/*
* Gallery
*/

window.Carousel_Gallery = function() {
  return {
    on: {
      init: function (swiper) {
        swiper.$el.closest('.carousel__container').find('.carousel__next').on('click', function (e) {
          swiper.$el.find('.swiper-button-next').trigger('click')
          e.stopPropagation()
          e.preventDefault()
        })

        swiper.$el.closest('.carousel__container').find('.carousel__prev').on('click', function (e) {
          swiper.$el.find('.swiper-button-prev').trigger('click')
          e.stopPropagation()
          e.preventDefault()
        })
      },
    },
  }
}
